import { BentoItem } from '../types';

import pageVenteLightMode from '../assets/img/page vente light mode.png';
import dashboard1 from '../assets/img/dashboard_1.png';
import gestionDepenses from '../assets/img/gestion depenses.png';
import gestionDettes from '../assets/img/gestion des dettes.png';
import gestionProduits from '../assets/img/gestion produit et categorie.png';
import alertStock from '../assets/img/alert stock.png';
import approvisionnement from '../assets/img/approvionnement.png';
import configParametrage from '../assets/img/cofig et paramettrage.png';
import allSales from '../assets/img/all sales.png';

export const bentoItems: BentoItem[] = [
  {
    title: 'Ventes POS',
    description:
      "Enregistrez une vente en 30 secondes. Scanner caméra, recherche intelligente, paiement espèces, Orange Money ou Wave.",
    image: pageVenteLightMode,
    badge: 'Mode POS',
    colSpan: 2,
  },
  {
    title: 'Dashboard',
    description:
      "Ventes, rentabilité, stock, trésorerie, dettes — 8 tableaux de bord pour tout voir en un coup d'œil.",
    image: dashboard1,
    badge: 'Temps réel',
    colSpan: 1,
  },
  {
    title: 'Dépenses',
    description:
      "Loyer, transport, fournisseurs — suivez chaque dépense et découvrez votre vraie rentabilité.",
    image: gestionDepenses,
    badge: 'Contrôle total',
    colSpan: 1,
  },
  {
    title: 'Dettes',
    description:
      "Chaque vente à crédit est tracée. Un client dit qu'il a payé ? Sortez les preuves en 1 clic.",
    image: gestionDettes,
    badge: 'Recouvrement',
    colSpan: 1,
  },
  {
    title: 'Produits & Stock',
    description:
      "Ajoutez vos produits, recevez des alertes avant la rupture, importez 500 produits en 5 min par Excel.",
    image: gestionProduits,
    overlayImage: alertStock,
    badge: 'Alertes stock',
    colSpan: 2,
  },
  {
    title: 'Approvisionnement',
    description:
      "Importez vos achats par Excel ou saisissez-les. Coût moyen et transport calculés automatiquement.",
    image: approvisionnement,
    badge: 'Import Excel',
    colSpan: 1,
  },
  {
    title: 'Configuration',
    description:
      "Logo, devise, politique de retour, thèmes — personnalisez votre boutique en quelques clics.",
    image: configParametrage,
    badge: '10 thèmes',
    colSpan: 1,
  },
  {
    title: 'Historique Ventes',
    description:
      "Retrouvez chaque transaction : filtres par date, vendeur, mode de paiement et détails complets.",
    image: allSales,
    badge: '19 ventes',
    colSpan: 1,
  },
];
